export default __webpack_public_path__ + "static/support-59bf55d541a6c5979c83adcb0317cfdd.svg";